/* eslint-disable react/require-default-props */
import React, { useCallback } from 'react';
import { Button, Checkbox, Toggle } from '@ui';
import { translate } from '@utils/i18n';
import './DeficiencyCardStyles.scss';
const NS = 'features.proposals.deficiencies_step';
const t = (key) => translate(key, { namespace: NS });
export function DeficiencyCard({ item, mode, isSelected, onOpenDetail, onPhotoClick, onSelectionChange, onRemove, onToggleIncludePhotos }) {
    const isLinked = mode === 'linked';
    const allPhotosIncluded = item.includedCount === item.photoCount && item.photoCount > 0;
    const handleCardClick = useCallback((e) => {
        const target = e.target;
        if (target.closest('[data-grid-photo]') ||
            target.closest('[data-grid-checkbox]') ||
            target.closest('[data-grid-action]') ||
            target.closest('[data-grid-toggle]')) {
            return;
        }
        onOpenDetail(item.id);
    }, [item.id, onOpenDetail]);
    const handleImageClick = useCallback((e) => {
        e.stopPropagation();
        if (item.thumbnailUrl) {
            onPhotoClick(item.id);
        }
    }, [item.id, item.thumbnailUrl, onPhotoClick]);
    const handleImageKeyDown = useCallback((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (item.thumbnailUrl) {
                onPhotoClick(item.id);
            }
        }
    }, [item.id, item.thumbnailUrl, onPhotoClick]);
    const handleCheckboxChange = useCallback((checked) => {
        onSelectionChange(item.id, checked);
    }, [item.id, onSelectionChange]);
    const handleRemove = useCallback((e) => {
        e.stopPropagation();
        onRemove === null || onRemove === void 0 ? void 0 : onRemove(item.id);
    }, [item.id, onRemove]);
    const handleTogglePhotos = useCallback((e) => {
        e.stopPropagation();
        onToggleIncludePhotos === null || onToggleIncludePhotos === void 0 ? void 0 : onToggleIncludePhotos(item.id, e.target.checked);
    }, [item.id, onToggleIncludePhotos]);
    const cardClass = ['deficiency-card', isSelected ? 'deficiency-card--selected' : '']
        .filter(Boolean)
        .join(' ');
    return (
    /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    React.createElement("article", { className: cardClass, "aria-label": `${t('deficiency_card')} ${item.number}`, onClick: handleCardClick },
        React.createElement("header", { className: "deficiency-card__header" },
            React.createElement("div", { className: "deficiency-card__checkbox", "data-grid-checkbox": true },
                React.createElement(Checkbox, { id: `grid-select-${item.id}`, checked: isSelected, onChange: handleCheckboxChange, "aria-label": `${t('select_deficiency')} ${item.number}` })),
            React.createElement("h3", { className: "deficiency-card__title" }, translate('card_title', { namespace: NS, number: item.number })),
            isLinked && (React.createElement(Button, { type: "button", variant: "default", className: "deficiency-card__remove", "data-grid-action": true, onClick: handleRemove, "aria-label": `${t('remove_deficiency')} ${item.number}` },
                React.createElement("i", { className: "fa-light fa-times", "aria-hidden": "true" })))),
        item.thumbnailUrl ? (React.createElement("button", { type: "button", className: "deficiency-card__image-button", "data-grid-photo": true, "aria-label": translate('view_photos_label', { namespace: NS, number: item.number }), onClick: handleImageClick, onKeyDown: handleImageKeyDown },
            React.createElement("img", { src: item.thumbnailUrl, alt: translate('thumbnail_alt', { namespace: NS, number: item.number }), className: "deficiency-card__thumbnail" }))) : (React.createElement("div", { className: "deficiency-card__image-wrapper", "data-grid-photo": true, "aria-hidden": "true" },
            React.createElement("div", { className: "deficiency-card__placeholder" },
                React.createElement("i", { className: "fa-light fa-image", "aria-hidden": "true" })))),
        item.severity && (React.createElement("span", { className: "deficiency-card__badge" }, translate('severity_label', { namespace: NS, severity: item.severity }))),
        React.createElement("div", { className: "deficiency-card__fields" },
            React.createElement("div", null,
                React.createElement("span", { className: "deficiency-card__field-label" }, t('field_question')),
                React.createElement("span", { className: "deficiency-card__field-value" }, item.question)),
            React.createElement("div", null,
                React.createElement("span", { className: "deficiency-card__field-label" }, t('field_answer')),
                React.createElement("span", { className: "deficiency-card__field-value" }, item.answer)),
            React.createElement("div", null,
                React.createElement("span", { className: "deficiency-card__field-label" }, t('field_system_asset_type')),
                React.createElement("span", { className: "deficiency-card__field-value" }, item.systemLabel))),
        isLinked && (React.createElement("div", { className: "deficiency-card__footer", "data-grid-toggle": true },
            React.createElement(Toggle, { checked: allPhotosIncluded, onChange: handleTogglePhotos, label: t('include_photos_on_proposal'), "aria-label": translate('include_photos_for', { namespace: NS, number: item.number }) })))));
}
